import { Property } from '@data/models';
import styled from '@emotion/styled';
import { FC } from 'react';
import OpenStreetMap from './OpenStreetMap';

const StyledMap = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 1.9;
    border-radius: 16px;
    overflow: hidden;
`;

const BEMap: FC<Property> = (props: Property) => {
  return (
    <StyledMap>
      <OpenStreetMap {...props} />
    </StyledMap>
  );
};

export default BEMap;
